export default {
  font:  '\'Ubuntu\',\'Ubisoft Sans Regular\',sans-serif',
  boldFont :  '\'Ubuntu\',\'Ubisoft Sans Regular\',sans-serif',
  fontWeight : '700'
};